import axios from 'axios';
import { API_URL } from '../../../config/api';

const API_BASE_URL = API_URL;

// Configurar instância do axios
const storeAPI = axios.create({
  baseURL: `${API_BASE_URL}/api/store`,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Interceptor para adicionar token de autenticação
storeAPI.interceptors.request.use(
  (config) => {
    // Adicionar token para todos os endpoints (para filtrar produtos do usuário)
    const token = localStorage.getItem('auth_token') || localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const storeService = {
  // Executar seed da loja (apenas para desenvolvimento)
  seedStore: async () => {
    try {
      const response = await storeAPI.post('/seed');
      return response.data;
    } catch (error) {
      console.error('Erro ao executar seed da loja:', error);
      throw error.response?.data || error.message;
    }
  },

  // Buscar produtos da loja
  getProducts: async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      
      if (filters.category && filters.category !== 'Todos') {
        params.append('category', filters.category);
      }
      
      if (filters.search) {
        params.append('search', filters.search);
      }

      if (filters.producer) {
        params.append('producer', filters.producer);
      }

      if (filters.userId) {
        params.append('userId', String(filters.userId));
      }

      if (typeof filters.exclude_my !== 'undefined') {
        params.append('exclude_my', String(filters.exclude_my));
      }

      // Adicionar parâmetros de paginação
      if (filters.page) {
        params.append('page', filters.page);
      }
      
      if (filters.limit) {
        params.append('limit', filters.limit);
      }

      const response = await storeAPI.get(`products?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar produtos da loja:', error);
      throw error.response?.data || error.message;
    }
  },

  // Buscar detalhes de um produto da loja
  getProductDetails: async (productId) => {
    try {
      const response = await storeAPI.get(`/products/${productId}`);
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao buscar detalhes do produto da loja:', error);
      throw error.response?.data || error.message;
    }
  },

  // Verificar status de afiliação de um produto
  getAffiliateStatus: async (productId, userId) => {
    try {
      const response = await storeAPI.get(`/products/${productId}/affiliate-status?userId=${userId}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao verificar status de afiliação:', error);
      throw error.response?.data || error.message;
    }
  },

  // Promover produto (tornar-se afiliado)
  promoteProduct: async (productId, userId) => {
    try {
      const response = await storeAPI.post(`/products/${productId}/promote`, {
        userId: userId
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao promover produto:', error);
      throw error.response?.data || error.message;
    }
  }
};

export default storeService;